<p class="mb-0"><span class="text-secondary">od:</span> {{ dialogData.sender }}</p>
<p class="mb-0"><span class="text-secondary">do:</span> {{ dialogData.addressee }}</p>
<p class="mb-0">
	<span class="text-secondary">data:</span>
	{{ dialogData.date | date: 'dd.MM.yyyy' }}
</p>
<p class="mb-0"><span class="text-secondary">temat:</span> {{ dialogData.subject }}</p>
